import { XTL_TRANSITION_TYPES } from './enums'

// function isSubInterval(intervalA, intervalB) {
//   const [ startA, endA ] = intervalA
//   const [ startB, endB ] = intervalB
//   return startB >= startA && endB <= endA
// }

// function mergeIntervals(arr) {
//   if (arr.length === 0) return []

//   const sorted = [ ...arr ].sort((a, b) => a[0] - b[0])

//   return sorted.reduce((acc, curr) => {
//     const last = acc[acc.length - 1]

//     if (last && curr[0] <= last[1]) {
//       last[1] = Math.max(last[1], curr[1])
//     } else {
//       acc.push([ ...curr ])
//     }
//     return acc
//   }, [])
// }

// function deduplicateIntervals(intervals) {
//   const intervalStrings = intervals.map(interval => interval.join(','))
//   const uniqueIntervalStrings = Array.from(new Set(intervalStrings))
//   return uniqueIntervalStrings.map(str => str.split(',').map(Number))
// }

// /**
//  * @param {number[][]} intervals
//  * @returns {number[][]}
//  */
// function excludeNestedAndDuplicateIntervals(intervals) {
//   const uniqueIntervals = deduplicateIntervals(intervals)

//   if (uniqueIntervals.length <= 1) {
//     return uniqueIntervals
//   }

//   const result = uniqueIntervals.filter((currentInterval, currentIndex) => {
//     let isNested = false

//     for (let i = 0; i < uniqueIntervals.length; i++) {
//       if (currentIndex === i) {
//         continue
//       }
//       const otherInterval = uniqueIntervals[i]
//       if (isSubInterval(otherInterval, currentInterval)) {
//         isNested = true
//         break
//       }
//     }
//     return !isNested
//   })
//   return mergeIntervals(result)
// }

// function getIntervals(asset, assetsGroup) {
//   const { startTime, endTime } = asset
//   return assetsGroup.reduce((res, groupAsset) => {
//     if (asset.id === groupAsset.id) {
//       return res
//     }
//     if (groupAsset.startTime >= startTime && groupAsset.endTime <= endTime) {
//       res.push([ num(groupAsset.startTime), num(groupAsset.endTime) ])
//     } else if (groupAsset.startTime <= startTime && groupAsset.endTime >= endTime) {
//       res.push([ num(Math.max(groupAsset.startTime, startTime)),
//         num(Math.min(groupAsset.endTime, endTime)) ])
//     } else if (groupAsset.startTime <= startTime && groupAsset.endTime <= endTime
//       && groupAsset.endTime >= startTime) {
//       res.push([ num(startTime), num(groupAsset.endTime) ])
//     } else if (groupAsset.startTime >= startTime
//       && groupAsset.startTime <= endTime && groupAsset.endTime >= endTime) {
//       res.push([ num(groupAsset.startTime), num(endTime) ])
//     }
//     return res
//   }, [])
// }

export const getAudioMix = asset => (
  `
  <transition
    type="${XTL_TRANSITION_TYPES.MIX}"
    start="${asset.startTime}"
    stop="${asset.endTime}"
    timeFormat="100ns_units"
  >
  </transition>
 `)
